<template>
  <div id="devicePlayer" v-loading="isLoging">
    <el-dialog title="视频播放" top="0" width="750px" :close-on-click-modal="false" :append-to-body="true" :visible.sync="showVideoDialog" @close="close()">
      <div style="width: 100%; min-height: 400px; background-color: #000;">
        <jessibucaPlayer v-if="activePlayer === 'jessibuca'" ref="jessibuca" :visible.sync="showVideoDialog" :device-id="deviceId" :channel-id="channelId"
                         :videoUrl="videoUrl" :error="videoError" :message="videoError" height="400px" :hasAudio="hasAudio" fluent
                         autoplay live></jessibucaPlayer>
<!--        <el-tabs type="card" :stretch="true" v-model="activePlayer" @tab-click="changePlayer"-->
<!--                 v-if="Object.keys(this.player).length > 1">-->
<!--          &lt;!&ndash;          <el-tab-pane label="LivePlayer" name="livePlayer">&ndash;&gt;-->
<!--          &lt;!&ndash;            <LivePlayer v-if="showVideoDialog" ref="livePlayer" :visible.sync="showVideoDialog" :videoUrl="videoUrl" :error="videoError" :message="videoError" :hasaudio="hasAudio" fluent autoplay live></LivePlayer>&ndash;&gt;-->
<!--          &lt;!&ndash;          </el-tab-pane>&ndash;&gt;-->
<!--          <el-tab-pane label="Jessibuca" name="jessibuca">-->
<!--            <jessibucaPlayer v-if="activePlayer === 'jessibuca'" ref="jessibuca" :visible.sync="showVideoDialog"-->
<!--                             :videoUrl="videoUrl" :error="videoError" :message="videoError" height="100px" :hasAudio="hasAudio" fluent-->
<!--                             autoplay live></jessibucaPlayer>-->
<!--          </el-tab-pane>-->
<!--          <el-tab-pane label="WebRTC" name="webRTC">-->
<!--            <rtc-player v-if="activePlayer === 'webRTC'" ref="webRTC" :visible.sync="showVideoDialog" :videoUrl="videoUrl"-->
<!--                        :error="videoError" :message="videoError" height="100px" :hasAudio="hasAudio" fluent autoplay-->
<!--                        live></rtc-player>-->
<!--          </el-tab-pane>-->
<!--          <el-tab-pane label="h265web">h265web敬请期待</el-tab-pane>-->
<!--          <el-tab-pane label="wsPlayer">wsPlayer 敬请期待</el-tab-pane>-->
<!--        </el-tabs>-->
<!--        <jessibucaPlayer v-if="Object.keys(this.player).length == 1 && this.player.jessibuca" ref="jessibuca"-->
<!--                         :visible.sync="showVideoDialog" :videoUrl="videoUrl" :error="videoError" :message="videoError" height="100px"-->
<!--                         :hasAudio="hasAudio" fluent autoplay live></jessibucaPlayer>-->
<!--        <rtc-player v-if="Object.keys(this.player).length == 1 && this.player.webRTC" ref="jessibuca"-->
<!--                    :visible.sync="showVideoDialog" :videoUrl="videoUrl" :error="videoError" :message="videoError" height="100px"-->
<!--                    :hasAudio="hasAudio" fluent autoplay live></rtc-player>-->

      </div>
      <div id="shared" style="margin-top: 1rem;">
        <el-tabs v-model="tabActiveName" @tab-click="tabHandleClick">
<!--          <el-tab-pane label="实时视频" name="media">-->
<!--            <div style="display: flex; margin-bottom: 0.5rem; height: 2.5rem;">-->
<!--              <span style="width: 5rem; line-height: 2.5rem; text-align: right;">播放地址：</span>-->
<!--              <el-input v-model="getPlayerShared.sharedUrl" :disabled="true">-->
<!--                <template slot="append">-->
<!--                  <i class="cpoy-btn el-icon-document-copy" title="点击拷贝" v-clipboard="getPlayerShared.sharedUrl"-->
<!--                     @success="$message({ type: 'success', message: '成功拷贝到粘贴板' })"></i>-->
<!--                </template>-->
<!--              </el-input>-->
<!--            </div>-->
<!--            <div style="display: flex; margin-bottom: 0.5rem; height: 2.5rem;">-->
<!--              <span style="width: 5rem; line-height: 2.5rem; text-align: right;">iframe：</span>-->
<!--              <el-input v-model="getPlayerShared.sharedIframe" :disabled="true">-->
<!--                <template slot="append">-->
<!--                  <i class="cpoy-btn el-icon-document-copy" title="点击拷贝" v-clipboard="getPlayerShared.sharedIframe"-->
<!--                     @success="$message({ type: 'success', message: '成功拷贝到粘贴板' })"></i>-->
<!--                </template>-->
<!--              </el-input>-->
<!--            </div>-->
<!--            <div style="display: flex; margin-bottom: 0.5rem; height: 2.5rem;">-->
<!--              <span style="width: 5rem; line-height: 2.5rem; text-align: right;">资源地址：</span>-->
<!--              <el-input v-model="getPlayerShared.sharedRtmp" :disabled="true">-->
<!--                <el-button slot="append" icon="el-icon-document-copy" title="点击拷贝"-->
<!--                           v-clipboard="getPlayerShared.sharedRtmp"-->
<!--                           @success="$message({ type: 'success', message: '成功拷贝到粘贴板' })"></el-button>-->
<!--                <el-dropdown slot="prepend" v-if="streamInfo" trigger="click" @command="copyUrl">-->
<!--                  <el-button>-->
<!--                    更多地址<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--                  </el-button>-->
<!--                  <el-dropdown-menu slot="dropdown">-->
<!--                    <el-dropdown-item v-if="streamInfo.flv" :command="streamInfo.flv">-->
<!--                      <el-tag>FLV:</el-tag>-->
<!--                      <span>{{ streamInfo.flv }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.https_flv" :command="streamInfo.https_flv">-->
<!--                      <el-tag>FLV(https):</el-tag>-->
<!--                      <span>{{ streamInfo.https_flv }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.ws_flv" :command="streamInfo.ws_flv">-->
<!--                      <el-tag>FLV(ws):</el-tag>-->
<!--                      <span>{{ streamInfo.ws_flv }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.wss_flv" :command="streamInfo.wss_flv">-->
<!--                      <el-tag>FLV(wss):</el-tag>-->
<!--                      <span>{{ streamInfo.wss_flv }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.fmp4" :command="streamInfo.fmp4">-->
<!--                      <el-tag>FMP4:</el-tag>-->
<!--                      <span>{{ streamInfo.fmp4 }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.https_fmp4" :command="streamInfo.https_fmp4">-->
<!--                      <el-tag>FMP4(https):</el-tag>-->
<!--                      <span>{{ streamInfo.https_fmp4 }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.ws_fmp4" :command="streamInfo.ws_fmp4">-->
<!--                      <el-tag>FMP4(ws):</el-tag>-->
<!--                      <span>{{ streamInfo.ws_fmp4 }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.wss_fmp4" :command="streamInfo.wss_fmp4">-->
<!--                      <el-tag>FMP4(wss):</el-tag>-->
<!--                      <span>{{ streamInfo.wss_fmp4 }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.hls" :command="streamInfo.hls">-->
<!--                      <el-tag>HLS:</el-tag>-->
<!--                      <span>{{ streamInfo.hls }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.https_hls" :command="streamInfo.https_hls">-->
<!--                      <el-tag>HLS(https):</el-tag>-->
<!--                      <span>{{ streamInfo.https_hls }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.ws_hls" :command="streamInfo.ws_hls">-->
<!--                      <el-tag>HLS(ws):</el-tag>-->
<!--                      <span>{{ streamInfo.ws_hls }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.wss_hls" :command="streamInfo.wss_hls">-->
<!--                      <el-tag>HLS(wss):</el-tag>-->
<!--                      <span>{{ streamInfo.wss_hls }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.ts" :command="streamInfo.ts">-->
<!--                      <el-tag>TS:</el-tag>-->
<!--                      <span>{{ streamInfo.ts }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.https_ts" :command="streamInfo.https_ts">-->
<!--                      <el-tag>TS(https):</el-tag>-->
<!--                      <span>{{ streamInfo.https_ts }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.ws_ts" :command="streamInfo.ws_ts">-->
<!--                      <el-tag>TS(ws):</el-tag>-->
<!--                      <span>{{ streamInfo.ws_ts }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.wss_ts" :command="streamInfo.wss_ts">-->
<!--                      <el-tag>TS(wss):</el-tag>-->
<!--                      <span>{{ streamInfo.wss_ts }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.rtc" :command="streamInfo.rtc">-->
<!--                      <el-tag>RTC:</el-tag>-->
<!--                      <span>{{ streamInfo.rtc }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.rtcs" :command="streamInfo.rtcs">-->
<!--                      <el-tag>RTCS:</el-tag>-->
<!--                      <span>{{ streamInfo.rtcs }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.rtmp" :command="streamInfo.rtmp">-->
<!--                      <el-tag>RTMP:</el-tag>-->
<!--                      <span>{{ streamInfo.rtmp }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.rtmps" :command="streamInfo.rtmps">-->
<!--                      <el-tag>RTMPS:</el-tag>-->
<!--                      <span>{{ streamInfo.rtmps }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.rtsp" :command="streamInfo.rtsp">-->
<!--                      <el-tag>RTSP:</el-tag>-->
<!--                      <span>{{ streamInfo.rtsp }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                    <el-dropdown-item v-if="streamInfo.rtsps" :command="streamInfo.rtsps">-->
<!--                      <el-tag>RTSPS:</el-tag>-->
<!--                      <span>{{ streamInfo.rtsps }}</span>-->
<!--                    </el-dropdown-item>-->
<!--                  </el-dropdown-menu>-->
<!--                </el-dropdown>-->
<!--              </el-input>-->

<!--            </div>-->
<!--          </el-tab-pane>-->
<!--          &lt;!&ndash;{"code":0,"data":{"paths":["22-29-30.mp4"],"rootPath":"/home/kkkkk/Documents/ZLMediaKit/release/linux/Debug/www/record/hls/kkkkk/2020-05-11/"}}&ndash;&gt;-->
<!--          &lt;!&ndash;遥控界面&ndash;&gt;-->
          <el-tab-pane label="云台控制" name="control" v-if="showPtz">
            <div class="ptz-container">
              <!-- 左侧：方向控制盘 -->
              <div class="ptz-left">
                <div class="control-wrapper">
                  <div class="control-btn control-top" @mousedown="ptzCamera('up')" @mouseup="ptzCamera('stop')">
                    <i class="el-icon-caret-top"></i>
                  </div>
                  <div class="control-btn control-left" @mousedown="ptzCamera('left')" @mouseup="ptzCamera('stop')">
                    <i class="el-icon-caret-left"></i>
                  </div>
                  <div class="control-btn control-center" @mouseup="ptzCamera('stop')">
                    <i class="fa fa-pause-circle"></i>
                  </div>
                  <div class="control-btn control-right" @mousedown="ptzCamera('right')" @mouseup="ptzCamera('stop')">
                    <i class="el-icon-caret-right"></i>
                  </div>
                  <div class="control-btn control-bottom" @mousedown="ptzCamera('down')" @mouseup="ptzCamera('stop')">
                    <i class="el-icon-caret-bottom"></i>
                  </div>
                </div>
                <!-- 变焦 & 速度 -->
                <div class="ptz-zoom-speed">
                  <div class="zoom-btns">
                    <span class="zoom-btn" @mousedown="ptzCamera('zoomin')" @mouseup="ptzCamera('stop')">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span class="zoom-btn" @mousedown="ptzCamera('zoomout')" @mouseup="ptzCamera('stop')">
                      <i class="el-icon-zoom-out"></i>
                    </span>
                  </div>
                  <div class="speed-slider">
                    <span class="speed-label">速度</span>
                    <el-slider v-model="controSpeed" :max="255" style="flex:1;min-width:80px;"></el-slider>
                  </div>
                </div>
              </div>

              <!-- 右侧：功能面板 -->
              <div class="ptz-right">
                <!-- 预置位 -->
                <div class="ptz-row">
                  <span class="ptz-label">预置位编号</span>
                  <el-input-number size="mini" v-model="presetPos" controls-position="right"
                                   :precision="0" :step="1" :min="1" :max="255"></el-input-number>
                  <el-button size="mini" icon="el-icon-add-location" @click="presetPosition(129, presetPos)">设置</el-button>
                  <el-button size="mini" icon="el-icon-delete-location" @click="presetPosition(131, presetPos)">删除</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-place" @click="presetPosition(130, presetPos)">调用</el-button>
                </div>
                <!-- 巡航速度 & 停留时间 -->
                <div class="ptz-row">
                  <span class="ptz-label">巡航速度</span>
                  <el-input-number size="mini" v-model="cruisingSpeed" controls-position="right"
                                   :precision="0" :min="1" :max="4095"></el-input-number>
                  <el-button size="mini" icon="el-icon-loading" @click="setSpeedOrTime(134, cruisingGroup, cruisingSpeed)">设置</el-button>
                  <span class="ptz-label">停留时间</span>
                  <el-input-number size="mini" v-model="cruisingTime" controls-position="right"
                                   :precision="0" :min="1" :max="4095"></el-input-number>
                  <el-button size="mini" icon="el-icon-timer" @click="setSpeedOrTime(135, cruisingGroup, cruisingTime)">设置</el-button>
                </div>
                <!-- 巡航组 -->
                <div class="ptz-row">
                  <span class="ptz-label">巡航组编号</span>
                  <el-input-number size="mini" v-model="cruisingGroup" controls-position="right"
                                   :precision="0" :min="0" :max="255"></el-input-number>
                  <el-button size="mini" icon="el-icon-add-location" @click="setCommand(132, cruisingGroup, presetPos)">添加点</el-button>
                  <el-button size="mini" icon="el-icon-delete-location" @click="setCommand(133, cruisingGroup, presetPos)">删除点</el-button>
                  <el-button size="mini" icon="el-icon-delete" @click="setCommand(133, cruisingGroup, 0)">删除组</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-video-camera-solid" @click="setCommand(136, cruisingGroup, 0)">巡航</el-button>
                </div>
                <!-- 扫描速度 & 组编号 -->
                <div class="ptz-row">
                  <span class="ptz-label">扫描速度</span>
                  <el-input-number size="mini" v-model="scanSpeed" controls-position="right"
                                   :precision="0" :min="1" :max="4095"></el-input-number>
                  <el-button size="mini" icon="el-icon-loading" @click="setSpeedOrTime(138, scanGroup, scanSpeed)">设置</el-button>
                  <span class="ptz-label">扫描组编号</span>
                  <el-input-number size="mini" v-model="scanGroup" controls-position="right"
                                   :precision="0" :step="1" :min="0" :max="255"></el-input-number>
                </div>
                <!-- 扫描边界 & 操作 -->
                <div class="ptz-row ptz-actions">
                  <el-button size="mini" icon="el-icon-d-arrow-left" @click="setCommand(137, scanGroup, 1)">左边界</el-button>
                  <el-button size="mini" icon="el-icon-d-arrow-right" @click="setCommand(137, scanGroup, 2)">右边界</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-video-camera-solid" @click="setCommand(137, scanGroup, 0)">开始扫描</el-button>
                  <el-button size="mini" type="danger" icon="el-icon-switch-button" @click="ptzCamera('stop')">停止</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
<!--          <el-tab-pane label="编码信息" name="codec" v-loading="tracksLoading">-->
<!--            <p>-->
<!--              无法播放或者没有声音?&nbsp&nbsp&nbsp试一试&nbsp-->
<!--              <el-button size="mini" type="primary" v-if="!coverPlaying" @click="coverPlay">转码播放</el-button>-->
<!--              <el-button size="mini" type="danger" v-if="coverPlaying" @click="convertStopClick">停止转码</el-button>-->
<!--            </p>-->
<!--            <div class="trank">-->
<!--              <p v-if="tracksNotLoaded" style="text-align: center;padding-top: 3rem;">暂无数据</p>-->
<!--              <div v-for="(item, index) in tracks" style="width: 50%; float: left" loading>-->
<!--                <span>流 {{ index }}</span>-->
<!--                <div class="trankInfo" v-if="item.codec_type == 0">-->
<!--                  <p>格式: {{ item.codec_id_name }}</p>-->
<!--                  <p>类型: 视频</p>-->
<!--                  <p>分辨率: {{ item.width }} x {{ item.height }}</p>-->
<!--                  <p>帧率: {{ item.fps }}</p>-->
<!--                </div>-->
<!--                <div class="trankInfo" v-if="item.codec_type == 1">-->
<!--                  <p>格式: {{ item.codec_id_name }}</p>-->
<!--                  <p>类型: 音频</p>-->
<!--                  <p>采样位数: {{ item.sample_bit }}</p>-->
<!--                  <p>采样率: {{ item.sample_rate }}</p>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->

<!--          </el-tab-pane>-->
          <el-tab-pane style="margin-left: 40%;" label="语音对讲" name="talkback">
            <div>
              对讲模式：
              <el-select v-model="broadCastModel" placeholder="请选择" :disabled="talkStatus">
                <el-option v-for="item in broadCastOption" :key="item.key" :label="item.key" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="talk-div" @click="talkHandle">
              <i :class="'el-icon-microphone'" :title="talkTitle"
                 :style="{ color: microphoneStatus ? 'rgba(25, 246, 5, 0.69)' : 'rgba(118, 118, 118, 0.742)' }"
                 v-if="canTalk"></i>

              <i :class="'el-icon-turn-off-microphone'" :title="talkTitle" v-if="!canTalk"></i>
            </div>
          </el-tab-pane>

          <!-- <el-tab-pane style="margin-left: 50%;" label="录音下发" name="record">
            <div>
              对讲模式：
              <el-select v-model="broadCastModel" placeholder="请选择" :disabled="talkStatus">
                <el-option v-for="item in broadCastOption" :key="item.key" :label="item.key" :value="item.value">
                </el-option>
              </el-select>
            </div>

            <div class="talk-div" @click="recordHandle">
              <i :class="'el-icon-video-play'" :title="recordTitle" v-if="recordStatus == false"></i>

              <i :class="'el-icon-video-pause'" :style="{ color: recordColorStatus ? '' : 'rgba(255, 0, 0, 0.742)' }"
                 :title="recordTitle" v-if="recordStatus == true"></i>

            </div>

          </el-tab-pane> -->
<!--          <el-tab-pane style="margin-left: 50%;" label="音频文件广播" name="fileBroadcast">-->
<!--            <el-upload-->
<!--              class="upload-demo"-->
<!--              ref="upload"-->
<!--              :action="getUrl()"-->
<!--              :on-preview="handlePreview"-->
<!--              :on-remove="handleRemove"-->
<!--              :on-change="handleChange"-->
<!--              :on-success="handleSuccess"-->
<!--              :file-list="fileList"-->
<!--              :headers="headers"-->
<!--              accept=".mp3"-->
<!--              name="mp3File"-->
<!--              :multiple="false"-->
<!--              :auto-upload="false">-->
<!--              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>-->
<!--              <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">下发文件</el-button>-->
<!--              <div slot="tip" class="el-upload__tip">只能上传MP3文件,且一次只能上传一个</div>-->
<!--            </el-upload>-->
<!--          </el-tab-pane>-->
        </el-tabs>
      </div>
    </el-dialog>
    <div>
      <div v-show="false">
        <video ref="video" controls autoplay style="text-align:left;">

        </video>

        <video ref='selfVideo' controls autoplay style="text-align:right;">

        </video>
      </div>
    </div>
  </div>
</template>

<script>
    import rtcPlayer from '../dialog/rtcPlayer.vue'
    import LivePlayer from '@liveqing/liveplayer'
    import jessibucaPlayer from '../common/jessibuca.vue'
    import { debounce } from 'lodash'
    import userService from "../service/UserService";
    export default {
        name: 'devicePlayer',
        props: {},
        components: {
            LivePlayer, jessibucaPlayer, rtcPlayer,
        },
        computed: {
            getPlayerShared: function () {
                return {
                    sharedUrl: window.location.origin + '/#/play/wasm/' + encodeURIComponent(this.videoUrl),
                    sharedIframe: '<iframe src="' + window.location.origin + '/#/play/wasm/' + encodeURIComponent(this.videoUrl) + '"></iframe>',
                    sharedRtmp: this.videoUrl
                };
            },
            canTalk() {
                var ishttps = 'https:' == document.location.protocol ? true : false;

                console.log("hasAudiohasAudiohasAudiohasAudio:" + this.hasAudio);
                if (!ishttps || !this.hasAudio) {
                    this.talkTitle = "由于浏览器安全策略本站必须得是https，并且开启通道音频选项才可以对讲";
                    return false;
                }
                this.talkTitle = "开始对讲";
                return true;
            }
        },
        created() {
            this.resetToInitialState();
            console.log(this.player)
            if (Object.keys(this.player).length === 1) {
                this.activePlayer = Object.keys(this.player)[0]
            }
            this.broadCastModel = this.broadCastOption[0].value;

        },
        data() {
            return {
              mp3Url:null,
              fileList: [],
              headers: {
                  "access-token": userService.getToken()
                },
                broadCastOption: [{
                    value: '0',
                    key: '国标对讲模式'
                },
                    {
                      value: '1',
                      key: '大华TALK模式'
                    }
                ],
                video: 'http://lndxyj.iqilu.com/public/upload/2019/10/14/8c001ea0c09cdc59a57829dabc8010fa.mp4',
                videoUrl: '',
                activePlayer: "jessibuca",
                // 如何你只是用一种播放器，直接注释掉不用的部分即可
                player: {
                    jessibuca: ["ws_flv", "wss_flv"],
                    livePlayer: ["ws_flv", "wss_flv"],
                    webRTC: ["rtc", "rtcs"],
                },
                showVideoDialog: false,
                streamId: '',
                app: '',
                mediaServerId: '',
                convertKey: '',
                deviceId: '',
                channelId: '',
                tabActiveName: 'talkback',
                hasAudio: false,
                loadingRecords: false,
                recordsLoading: false,
                isLoging: false,
                controSpeed: 30,
                timeVal: 0,
                timeMin: 0,
                timeMax: 1440,
                presetPos: 1,
                cruisingSpeed: 100,
                cruisingTime: 5,
                cruisingGroup: 0,
                scanSpeed: 100,
                scanGroup: 0,
                tracks: [],
                coverPlaying: false,
                tracksLoading: false,
                showPtz: true,
                showRrecord: true,
                tracksNotLoaded: false,
                sliderTime: 0,
                seekTime: 0,
                recordStartTime: 0,
                showTimeText: "00:00:00",
                streamInfo: null,
                talkTitle: null,
                talkStatus: false,
                microphoneStatus: false,
                talkInterval: null,
                zlmRTCClient: null,
                broadCastModel: null,
                recordTitle: "开始录音",
                recordStatus: false,
                recordColorStatus: false,
                recordColorStatusInterval: null
            };
        },
        methods: {
            resetToInitialState() {
              // 重置所有数据到初始状态
              Object.assign(this.$data, this.$options.data.call(this))
            },
            setHead(){
                return {"access-token":UserService.getto}
            },
            getUrl(){
              if(process.env.BASE_API != null) {
                return window.location.href.split("#")[0] + process.env.BASE_API.replace("/","") + `/api/talkback/sendAudioFileToDevice/${this.deviceId}/${this.channelId}/${this.streamId}`
              } else {
                return window.location.href.split("#")[0] + `api/talkback/sendAudioFileToDevice/${this.deviceId}/${this.channelId}/${this.streamId}`
              }


            },
            submitUpload() {
              this.$refs.upload.submit();

            },
            handleRemove(file, fileList) {

            },
            handlePreview(file) {

            },
            handleChange(file, fileList){
              if (fileList.length>0) {
                this.fileList=[fileList[fileList.length-1]]
              }
            },
            handleSuccess(response, file, fileList){
              console.log(response);
              if(response.code === 0){
                this.$message({
                                showClose: true,
                                message: '下发成功',
                                type: 'success'
                            });
              } else {
                this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'error'
                            });
              }

            },
            tabHandleClick: function (tab, event) {
                console.log(tab)
                var that = this;
                that.tracks = [];
                that.tracksLoading = true;
                that.tracksNotLoaded = false;
                if (tab.name === "codec") {
                    this.$axios({
                        method: 'get',
                        url: './zlm/' + this.mediaServerId + '/index/api/getMediaInfo?vhost=__defaultVhost__&schema=rtsp&app=' + this.app + '&stream=' + this.streamId
                    }).then(function (res) {
                        that.tracksLoading = false;
                        if (res.data.code == 0 && res.data.tracks) {
                            that.tracks = res.data.tracks;
                        } else {
                            that.tracksNotLoaded = true;
                            that.$message({
                                showClose: true,
                                message: '获取编码信息失败,',
                                type: 'warning'
                            });
                        }
                    }).catch(function (e) { });
                }
            },
            changePlayer: function (tab) {
                console.log(this.player[tab.name][0])
                this.activePlayer = tab.name;
                this.videoUrl = this.getUrlByStreamInfo()
                console.log(this.videoUrl)
            },
            openDialog: function (tab, deviceId, channelId, param) {

                if (this.showVideoDialog) {
                    return;
                }
                // this.tabActiveName = tab;
                this.channelId = channelId;
                this.deviceId = deviceId;
                this.streamId = "";
                this.mediaServerId = "";
                this.app = "";
                this.videoUrl = ""
                if (!!this.$refs[this.activePlayer]) {
                    this.$refs[this.activePlayer].pause();
                }

                if (param.manufacture === 'Dahua') {
                    this.broadCastModel = this.broadCastOption[1].value;
                }

                switch (tab) {
                    case "media":
                        this.play(param.streamInfo, param.hasAudio)
                        break;
                    case "streamPlay":
                        this.tabActiveName = "media";
                        this.showRrecord = false;
                        this.showPtz = false;
                        this.play(param.streamInfo, param.hasAudio)
                        break;
                    case "control":
                        break;
                }


            },
            play: function (streamInfo, hasAudio) {
                this.streamInfo = streamInfo;
                this.hasAudio = hasAudio;
                this.isLoging = false;
                // this.videoUrl = streamInfo.rtc;
                this.videoUrl = this.getUrlByStreamInfo();
                this.streamId = streamInfo.stream;
                this.app = streamInfo.app;
                this.mediaServerId = streamInfo.mediaServerId;
                this.playFromStreamInfo(false, streamInfo)
            },
            getUrlByStreamInfo() {
                console.log(this.streamInfo)
                if (location.protocol === "https:") {
                    this.videoUrl = this.streamInfo[this.player[this.activePlayer][1]]
                } else {
                    this.videoUrl = this.streamInfo[this.player[this.activePlayer][0]]
                }
                return this.videoUrl;

            },
            coverPlay: function () {
                var that = this;
                this.coverPlaying = true;
                this.$refs[this.activePlayer].pause()
                that.$axios({
                    method: 'post',
                    url: './api/play/convert/' + that.streamId
                }).then(function (res) {
                    if (res.data.code === 0) {
                        that.convertKey = res.data.key;
                        setTimeout(() => {
                            that.isLoging = false;
                            that.playFromStreamInfo(false, res.data.data);
                        }, 2000)
                    } else {
                        that.isLoging = false;
                        that.coverPlaying = false;
                        that.$message({
                            showClose: true,
                            message: '转码失败',
                            type: 'error'
                        });
                    }
                }).catch(function (e) {
                    console.log(e)
                    that.coverPlaying = false;
                    that.$message({
                        showClose: true,
                        message: '播放错误',
                        type: 'error'
                    });
                });
            },
            convertStopClick: function () {
                this.convertStop(() => {
                    this.$refs[this.activePlayer].play(this.videoUrl)
                });
            },
            stopDevicePush: function () {
              var that = this;
              this.$axios({
                method: 'get',
                url: '/api/play/stop/' + this.deviceId + "/" + this.channelId,
                params:{
                  isSubStream: false
                }
              }).then(function (res) {
                that.initData();
              }).catch(function (error) {
                if (error.response.status === 402) { // 已经停止过
                  that.initData();
                } else {
                  console.log(error)
                }
              });
            },
            convertStop: function (callback) {
                var that = this;
                that.$refs.videoPlayer.pause()
                this.$axios({
                    method: 'post',
                    url: './api/play/convertStop/' + this.convertKey
                }).then(function (res) {
                    if (res.data.code == 0) {
                        console.log(res.data.msg)
                    } else {
                        console.error(res.data.msg)
                    }
                    if (callback) callback();
                }).catch(function (e) { });
                that.coverPlaying = false;
                that.convertKey = "";
                // if (callback )callback();
            },

            playFromStreamInfo: function (realHasAudio, streamInfo) {
                this.showVideoDialog = true;
                this.hasaudio = realHasAudio && this.hasaudio;
                this.$refs[this.activePlayer].play(this.getUrlByStreamInfo(streamInfo))
            },
            close: function () {
                console.log('关闭视频');
                if (!!this.$refs[this.activePlayer]) {
                    this.$refs[this.activePlayer].pause();
                }
                this.videoUrl = '';
                this.coverPlaying = false;
                this.showVideoDialog = false;
                // this.stopDevicePush();
                if (this.convertKey !== '') {
                    this.convertStop();
                }
                this.convertKey = '';

                if (this.talkStatus) {
                    this.stopTalk();
                }
                this.broadCastModel = this.broadCastOption[0].value;

            },

            copySharedInfo: function (data) {
                console.log('复制内容：' + data);
                this.coverPlaying = false;
                this.tracks = []
                let _this = this;
                this.$copyText(data).then(
                    function (e) {
                        _this.$message({
                            showClose: true,
                            message: '复制成功',
                            type: 'success'
                        });
                    },
                    function (e) {
                        _this.$message({
                            showClose: true,
                            message: '复制失败，请手动复制',
                            type: 'error'
                        });
                    }
                );
            },
            ptzCamera: function (command) {
                console.log('云台控制：' + command);
                let that = this;
                this.$axios({
                    method: 'post',
                    url: './api/ptz/control/' + this.deviceId + '/' + this.channelId + '?command=' + command + '&horizonSpeed=' + this.controSpeed + '&verticalSpeed=' + this.controSpeed + '&zoomSpeed=' + this.controSpeed
                }).then(function (res) { });
            },
            //////////////////////播放器事件处理//////////////////////////
            videoError: function (e) {
                console.log("播放器错误：" + JSON.stringify(e));
            },
            presetPosition: function (cmdCode, presetPos) {
                console.log('预置位控制：' + this.presetPos + ' : 0x' + cmdCode.toString(16));
                let that = this;
                this.$axios({
                    method: 'post',
                    url: './api/ptz/front_end_command/' + this.deviceId + '/' + this.channelId + '?cmdCode=' + cmdCode + '&parameter1=0&parameter2=' + presetPos + '&combindCode2=0'
                }).then(function (res) { });
            },
            setSpeedOrTime: function (cmdCode, groupNum, parameter) {
                let that = this;
                let parameter2 = parameter % 256;
                let combindCode2 = Math.floor(parameter / 256) * 16;
                console.log('前端控制：0x' + cmdCode.toString(16) + ' 0x' + groupNum.toString(16) + ' 0x' + parameter2.toString(16) + ' 0x' + combindCode2.toString(16));
                this.$axios({
                    method: 'post',
                    url: './api/ptz/front_end_command/' + this.deviceId + '/' + this.channelId + '?cmdCode=' + cmdCode + '&parameter1=' + groupNum + '&parameter2=' + parameter2 + '&combindCode2=' + combindCode2
                }).then(function (res) { });
            },
            setCommand: function (cmdCode, groupNum, parameter) {
                let that = this;
                console.log('前端控制：0x' + cmdCode.toString(16) + ' 0x' + groupNum.toString(16) + ' 0x' + parameter.toString(16) + ' 0x0');
                this.$axios({
                    method: 'post',
                    url: './api/ptz/front_end_command/' + this.deviceId + '/' + this.channelId + '?cmdCode=' + cmdCode + '&parameter1=' + groupNum + '&parameter2=' + parameter + '&combindCode2=0'
                }).then(function (res) { });
            },
            copyUrl: function (dropdownItem) {
                console.log(dropdownItem)
                this.$copyText(dropdownItem).then((e) => {
                    this.$message.success("成功拷贝到粘贴板");
                }, (e) => {

                })
            },
            talkHandle() {
                // !this.talkStatus && this.canTalk
                if (!this.talkStatus && this.canTalk) {
                    //下发指令成功后话筒闪烁
                    if (this.talkInterval != null) {
                        clearInterval(this.talkInterval)
                    }
                    this.talkInterval = setInterval(() => {
                        this.microphoneStatus = !this.microphoneStatus;
                    }, 500);
                    this.startTalk();

                } else if (this.talkStatus == true) {
                    this.stopTalk();
                }

            },
            startTalk: debounce(function () {
                var _that = this;
                this.talkStatus = true;
                //1.第一步获取webrtc推流地址
                this.$axios({
                    method: 'get',
                    url: `/api/talkback/getWebRtcAddr/${this.deviceId}/${this.channelId}`
                }).then(res => {

                    if (res.data.code != 0) {
                        this.$message({
                            message: res.data.msg,
                            type: "error",
                        });

                        this.talkStatusChange();
                        return;
                    }
                    let webRtcPushUrl = res.data.data.webRtcPushUrl;
                    let app = res.data.data.app;
                    let stream = res.data.data.stream;

                    // 1.5 预热AudioContext：Chrome首次创建AudioContext可能不稳定，
                    // 因此先创建一个临时AudioContext用于热身，确保后续WebRTC推流稳定
                    var doPush = function() {
                        //2.拿到webrtc地址先推流
                        _that.zlmRTCClient = new window.ZLMRTCClient.Endpoint({
                        element: _that.$refs.video,// video 标签
                        debug: false,// 是否打印日志
                        zlmsdpUrl: webRtcPushUrl,//流地址
                        simulcast: false,
                        useCamera: false,
                        audioEnable: true,
                        videoEnable: false,
                        recvOnly: false,
                        resolution: { w: 0, h: 0 },
                        usedatachannel: false,
                    });

                    _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ICE_CANDIDATE_ERROR, function (e) {// ICE 协商出错
                        console.log('ICE 协商出错')
                        _that.$message({
                            message: e.msg,
                            type: "error",
                        });
                        _that.talkStatusChange();
                    });


                    _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED, function (e) {// offer anwser 交换失败
                        console.log('offer anwser 交换失败', e);
                        _that.$message({
                            message: e.msg,
                            type: "error",
                        });
                        if (e.msg === "already publishing") {
                            _that.webrtcStop();

                        }
                        _that.talkStatusChange();
                    });

                    _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_LOCAL_STREAM, function (s) {// 获取到了本地流

                        _that.$refs.selfVideo.srcObject = s;
                        _that.$refs.selfVideo.muted = true;

                        // 检测音频流是否有实际数据（避免AudioContext硬件错误导致静音推流）
                        var audioTracks = s.getAudioTracks();
                        if (audioTracks && audioTracks.length > 0) {
                            try {
                                var audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                                var source = audioCtx.createMediaStreamSource(s);
                                var analyser = audioCtx.createAnalyser();
                                analyser.fftSize = 256;
                                source.connect(analyser);
                                var dataArray = new Uint8Array(analyser.frequencyBinCount);
                                var checkCount = 0;
                                var maxChecks = 10; // 检测10次，每次500ms
                                var audioCheckInterval = setInterval(function () {
                                    analyser.getByteFrequencyData(dataArray);
                                    var hasAudio = false;
                                    for (var i = 0; i < dataArray.length; i++) {
                                        if (dataArray[i] > 10) { hasAudio = true; break; }
                                    }
                                    checkCount++;
                                    if (hasAudio) {
                                        console.log('[对讲] 检测到有效音频数据');
                                        clearInterval(audioCheckInterval);
                                        audioCtx.close();
                                        return;
                                    }
                                    if (checkCount >= maxChecks) {
                                        clearInterval(audioCheckInterval);
                                        audioCtx.close();
                                        console.warn('[对讲] 警告：5秒内未检测到有效音频数据，音频流可能异常');
                                        _that.$message({
                                            message: "麦克风可能无声音输入，请检查权限和音频设备",
                                            type: "warning",
                                            duration: 5000
                                        });
                                    }
                                }, 500);
                                // 组件关闭时清理
                                _that._audioCheckInterval = audioCheckInterval;
                                _that._audioCheckCtx = audioCtx;
                            } catch (e) {
                                console.error('[对讲] AudioContext创建失败:', e);
                                _that.$message({
                                    message: "音频设备初始化失败，请检查浏览器音频权限",
                                    type: "error",
                                    duration: 5000
                                });
                            }
                        }
                    });

                    _that.zlmRTCClient.on(ZLMRTCClient.Events.CAPTURE_STREAM_FAILED, function (s) {// 获取本地流失败

                        console.log('获取本地流失败')
                        _that.$message({
                            message: "获取本地流失败,请检查是否有麦克风",
                            type: "error",
                        });
                        _that.talkStatusChange();
                    });

                    _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_CONNECTION_STATE_CHANGE, function (state) {// RTC 状态变化 ,详情参考 https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/connectionState
                        console.log('当前状态==>', state)
                        if (state === "connected") {
                            //推流成功开始下发语音对讲指令
                            _that.$axios({
                                method: 'get',
                                url: `/api/talkback/start/${_that.deviceId}/${_that.channelId}/${app}/${stream}/${_that.broadCastModel}`
                            }).then(res => {
                                if (res.data.code !== 0) {
                                    _that.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                    _that.webrtcStop();
                                    _that.talkStatusChange();
                                    return;
                                } else {
                                    _that.$message({
                                        message: "开始对讲",
                                        type: "success",
                                    });
                                    _that.talkTitle = "停止对讲";
                                }
                                //console.log(this.el-icon-microphone);

                            }).catch(error => {
                                _that.$message({
                                    message: "对讲指令下发失败",
                                    type: "error",
                                });
                                _that.stopTalk();
                            })
                        } else if (state === "failed") {
                            _that.$message({
                                message: "webrtc推流失败，请检查流媒体配置",
                                type: "error",
                            });
                            _that.talkStatusChange();
                        }
                    });

                    _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_DATA_CHANNEL_OPEN, function (event) {
                        console.log('rtc datachannel 打开 :', event)
                    });

                    _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_DATA_CHANNEL_ERR, function (event) {
                        console.log('rtc datachannel 错误 :', event)
                    });

                    _that.zlmRTCClient.on(ZLMRTCClient.Events.WEBRTC_ON_DATA_CHANNEL_CLOSE, function (event) {
                        console.log('rtc datachannel 关闭 :', event)
                    });

                    }; // end of doPush

                    // AudioContext预热：提前打开麦克风+AudioContext，避免Chrome首次冷启动导致WebRTC断开
                    // 关键修复：预热资源在对讲期间保持活跃不清理，防止 track.stop() 传播导致 WebRTC 断开
                    // 仅在用户主动停止对讲时（stopTalk/webrtcStop）才清理
                    var _warmupStream = null;
                    var _warmupCtx = null;
                    var _warmupTimeout = null;
                    var _warmupDone = false;
                    var _warmupCleanup = function() {
                        if (_warmupTimeout) { clearTimeout(_warmupTimeout); _warmupTimeout = null; }
                        if (_warmupCtx) {
                            try { _warmupCtx.close(); } catch(e) {}
                            _warmupCtx = null;
                        }
                        if (_warmupStream) {
                            _warmupStream.getTracks().forEach(function(t) { t.stop(); });
                            _warmupStream = null;
                        }
                    };
                    // 挂到实例上，stopTalk时清理
                    _that._warmupCleanup = _warmupCleanup;

                    var safeDoPush = function() {
                        if (_warmupDone) return;
                        _warmupDone = true;
                        console.log('[对讲] 开始正式推流（AudioContext已预热，预热资源保持活跃）');
                        doPush();
                        // 不清理预热！保持麦克风轨和AudioContext活跃，防止Chrome关闭WebRTC
                    };
                    try {
                        navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(function(ws) {
                            _warmupStream = ws;
                            _warmupCtx = new (window.AudioContext || window.webkitAudioContext)();
                            var warmupSrc = _warmupCtx.createMediaStreamSource(ws);
                            var warmupAnalyser = _warmupCtx.createAnalyser();
                            warmupSrc.connect(warmupAnalyser);
                            // 等待1.5秒让AudioContext完成初始化
                            _warmupTimeout = setTimeout(function() {
                                console.log('[对讲] AudioContext预热完成，开始正式推流');
                                safeDoPush();
                            }, 1500);
                        }).catch(function(e) {
                            console.warn('[对讲] AudioContext预热失败（可能无麦克风权限），跳过预热直接推流:', e.message);
                            _warmupCleanup();
                            doPush();
                        });
                        // 超时保护：3秒后无论如何开始推流
                        setTimeout(function() {
                            if (_warmupTimeout) {
                                clearTimeout(_warmupTimeout);
                                _warmupTimeout = null;
                                console.warn('[对讲] AudioContext预热超时，强制开始推流');
                                safeDoPush();
                            }
                        }, 3000);
                    } catch(e) {
                        console.warn('[对讲] AudioContext预热异常，跳过直接推流:', e);
                        _warmupCleanup();
                        doPush();
                    }


                }).catch(res => {
                    _that.talkStatusChange();

                    _that.$message({
                        message: res,
                        type: "error",
                    });

                })
            }, 500),

            stopTalk() {
                //停止对讲

                // 清理预热资源（即使WebRTC客户端未创建也要清理）
                if (this._warmupCleanup) {
                    this._warmupCleanup();
                    this._warmupCleanup = null;
                }

                if (this.zlmRTCClient) {
                    this.$message({
                        message: "停止对讲",
                        type: "success",
                    });
                    this.webrtcStop();
                    // 异步调用后端API清理对讲状态，避免仅依赖ZLM hook导致状态残留
                    this.$axios({
                        method: 'get',
                        url: `/api/talkback/stop/${this.deviceId}/${this.channelId}`
                    }).then(res => {
                        console.log('停止对讲响应:', res.data);
                    }).catch(error => {
                        console.error('停止对讲请求失败:', error);
                    });
                    this.talkStatusChange();
                }
            },

            talkStatusChange() {
                this.talkTitle = "开始对讲";
                this.talkStatus = false;
                clearInterval(this.talkInterval);
                this.microphoneStatus = false;
                // 清理预热资源（麦克风轨 + AudioContext），防止泄漏
                if (this._warmupCleanup) {
                    this._warmupCleanup();
                    this._warmupCleanup = null;
                }
                // 清理音频检测资源
                if (this._audioCheckInterval) {
                    clearInterval(this._audioCheckInterval);
                    this._audioCheckInterval = null;
                }
                if (this._audioCheckCtx) {
                    try { this._audioCheckCtx.close(); } catch (e) {}
                    this._audioCheckCtx = null;
                }
            },
            webrtcStop() {
                this.zlmRTCClient.close();
                var remote = this.$refs.video;
                if (remote) {
                    remote.srcObject = null;
                    remote.load();
                }
                var local = this.$refs.selfVideo;
                local.srcObject = null;
                local.load();
                // 清理音频检测资源
                if (this._audioCheckInterval) {
                    clearInterval(this._audioCheckInterval);
                    this._audioCheckInterval = null;
                }
                if (this._audioCheckCtx) {
                    try { this._audioCheckCtx.close(); } catch (e) {}
                    this._audioCheckCtx = null;
                }
            },

            recordHandle() {
                if (!this.canTalk) {
                    alert(this.talkTitle);
                    return
                }

                this.recordStatus = !this.recordStatus;

                if (this.recordColorStatusInterval != null) {
                    clearInterval(this.recordColorStatusInterval)
                }
                this.recordColorStatusInterval = setInterval(() => {
                    this.recordColorStatus = !this.recordColorStatus;
                }, 500);
            }

        }
    };
</script>

<style scoped>
/* ========== 云台控制整体布局 ========== */
.ptz-container {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-wrap: wrap;
}

/* 左侧：方向盘 + 变焦/速度 */
.ptz-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

/* 方向控制盘 - Grid 布局 */
.control-wrapper {
  display: grid;
  grid-template-columns: 44px 44px 44px;
  grid-template-rows: 44px 44px 44px;
  gap: 4px;
  place-items: center;
}

.control-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #78aee4;
  box-sizing: border-box;
  transition: all 0.2s;
  cursor: pointer;
  background: #fff;
}
.control-btn:hover { background: rgba(120, 174, 228, 0.12); }
.control-btn:active { background: rgba(120, 174, 228, 0.25); }
.control-btn i {
  font-size: 20px;
  color: #78aee4;
}

.control-zoom-btn { cursor: pointer; }

.control-top {
  grid-column: 2;
  grid-row: 1;
}
.control-left {
  grid-column: 1;
  grid-row: 2;
}
.control-center {
  grid-column: 2;
  grid-row: 2;
  border-radius: 50%;
  background: #fafafa;
  font-size: 26px;
}
.control-right {
  grid-column: 3;
  grid-row: 2;
}
.control-bottom {
  grid-column: 2;
  grid-row: 3;
}

/* 变焦 + 速度 */
.ptz-zoom-speed {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.zoom-btns {
  display: flex;
  gap: 8px;
}
.zoom-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #78aee4;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #78aee4;
  font-size: 22px;
  transition: all 0.2s;
}
.zoom-btn:hover { background: rgba(120, 174, 228, 0.1); }
.zoom-btn:active { background: rgba(120, 174, 228, 0.25); }

.speed-slider {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-top: 4px;
}
.speed-label {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}

/* 右侧面板 */
.ptz-right {
  flex: 1;
  min-width: 240px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ptz-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.ptz-label {
  font-size: 12px;
  color: #606266;
  white-space: nowrap;
  min-width: 3.2rem;
  text-align: right;
  font-weight: 500;
}
.ptz-row /deep/ .el-input-number { width: 85px; }
.ptz-row /deep/ .el-input-number .el-input__inner { padding-left: 4px; padding-right: 24px; }
.ptz-row /deep/ .el-button--mini { padding: 5px 7px; font-size: 11px; }

.ptz-actions {
  margin-top: 4px;
  padding-top: 6px;
  border-top: 1px dashed #DCDFE6;
}

/* 编码信息 */
.trank {
  width: 80%;
  height: 180px;
  text-align: left;
  padding: 0 10%;
  overflow: auto;
}
.trankInfo {
  width: 80%;
  padding: 0 10%;
}

/* 语音对讲 */
.talk-div {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #8080809c;
  margin-left: 200px;
  position: relative;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  font-size: 60px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/devicePlayer.vue